import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

import { cx } from '@/styles/muiTheme';

interface UnsavedChangesDialogProps {
  open: boolean;
  configKey: string;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

/** Shown when a dirty draft is about to be replaced by another config. */
const UnsavedChangesDialog = ({
  open,
  configKey,
  onKeepEditing,
  onDiscard,
}: UnsavedChangesDialogProps) => (
  <Dialog open={open} onClose={onKeepEditing} maxWidth="xs">
    <DialogTitle sx={{ color: cx.text.primary }}>Discard unsaved changes?</DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ color: cx.text.tertiary }}>
        Your edits to{' '}
        <Box component="strong" sx={{ color: cx.text.primary }}>
          {configKey}
        </Box>{' '}
        have not been saved. Leaving now throws them away — nothing is written and no version is
        created.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onKeepEditing} sx={{ color: cx.text.tertiary }}>
        Keep editing
      </Button>
      <Button onClick={onDiscard} sx={{ color: cx.red.main }}>
        Discard
      </Button>
    </DialogActions>
  </Dialog>
);

export default UnsavedChangesDialog;
